module.exports = __webpack_public_path__ + "static/media/home.8bc2aae2.svg";